







import Vue from 'vue'
import moment from 'moment'
import request from '@/utils/request'
export default Vue.extend({
    data() {
      return {
          id: '' as any,
          data: {},
      }
    },
    // async created() {
    // },
    async mounted() {
        this.id = this.$route.params.id
        // console.log(this.$route.params)
        await this.getData()
        // this.updatedImage()
    },
    methods: {
        getData() {
            request.get(`/api/farming/product/${this.id}`).then((res: any) => this.data = res)
        },
        updatedImage() {
            let content = {} as any
            content = document.getElementById('content')
            console.log(content)
            const imgs = content.getElementsByTagName('imgs')
            console.log(imgs)
            for (const i of imgs) {
                // console.log(i)
                // console.log(i.parentNode)
                // i.parentNode.style.background = 'red'
                i.parentNode.parentNode.style.position = 'relative'
                i.parentNode.style.display = 'inline-block'
                i.parentNode.style.position = 'relative'
                i.parentNode.style.left = '50%'
                i.parentNode.style.transform = 'translateX(-50%)'
                i.style.display = 'block'
                i.style.width = '100%'
                i.style.height = '100%'
            }
        },
    },
    filters: {
        dtFormat(timestamp: number) {
            const time = moment(timestamp)
            return time.format('YYYY-MM-DD')
        },
    },
})
